import React from 'react';

const FrontsInfoPopup = () => {
  return (
    <>
      <p>
        Kolor paneli, z których zbudowane są drzwi szafy musisz dobierać parami ze względu na sposób
        pakowania i dystrybucji. Za pomocą tych ikon możesz wybrać wzór według którego będą
        rozmieszczone pary paneli.
      </p>
      <div className="example-info">
        <p className="example-info__text">Przykładowe zestawienia</p>
      </div>
      <div className="fronts-info">
        <div className="fronts-info__box">
          <img
            className="fronts-info__icon"
            src={`${process.env.PUBLIC_URL}/img/lowerWardrobe.svg`}
            alt="normal"
          />
          <div className="flex">
            <img
              className="fronts-info__img"
              src={`${process.env.PUBLIC_URL}/img/front-pattern/1.png`}
              alt="normal pattern"
            />
            <img
              className="fronts-info__img"
              src={`${process.env.PUBLIC_URL}/img/front-pattern/2.png`}
              alt="normal pattern"
            />
            <img
              className="fronts-info__img"
              src={`${process.env.PUBLIC_URL}/img/front-pattern/3.png`}
              alt="normal pattern"
            />
          </div>
        </div>
        <div className="fronts-info__box">
          <img
            className="fronts-info__icon"
            src={`${process.env.PUBLIC_URL}/img/higherWardrobe.svg`}
            alt="chessboard"
          />
          <div className="flex">
            <img
              className="fronts-info__img"
              src={`${process.env.PUBLIC_URL}/img/front-pattern/4.png`}
              alt="chess pattern"
            />
            <img
              className="fronts-info__img"
              src={`${process.env.PUBLIC_URL}/img/front-pattern/5.png`}
              alt="chess pattern"
            />
            <img
              className="fronts-info__img"
              src={`${process.env.PUBLIC_URL}/img/front-pattern/6.png`}
              alt="chess pattern"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FrontsInfoPopup;
